import {Controller} from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
    static values = {
      cart: Boolean
    }
    connect() {
        console.log('tests form connected', this.element)
        // // submit the form on connect to fill the test list
        const that = $(this.element);
        // setTimeout((() => this.submitSearch(that)), 10);
        // const event = new Event('init_select2', {bubbles: true})
        // document.dispatchEvent(event)
    }

    submitSearch(elem) {
        console.log('submit after load');
        if (document.getElementById('initial-tests-load')) {
            console.log('retry to load tests');
            $('.submit-btn').click();
            setTimeout((() => this.submitSearch(elem)), 250);
        } else {
            console.log('tests are loaded');
        }
    }

    submit() {
        console.log('submit test search')
        $('.submit-btn').click()
    }

    reset() {
        if (this.cartValue) {
            alert('reveal')
        } else {

        }
    }
}
